import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Helmet } from 'react-helmet';
import { ConfigProvider } from './Context/ConfigContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId='442822980680-vl88rmllklol56rs7n4kcvhnciosg9ju.apps.googleusercontent.com'>
    <ConfigProvider>
      <Helmet>
        <link rel="canonical" href="https://www.ghayar.com" />
      </Helmet>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </ConfigProvider>
  </GoogleOAuthProvider>
);
reportWebVitals();
